import { Injectable } from '@angular/core';
import {
  ProductOfferingBenefit,
  ProductOfferingFeature,
  ProductOfferingPlatform,
} from '@mkp/shared/models';
import {
  getBenefitsFromFeatures,
  getFeaturesFromProducts,
  getPlatformsFromFeatures,
  orderFeatures,
  removeApprenticeshipProducts,
} from '@mkp/shared/util-product';
import {
  selectActivePlatformGroup,
  selectDisplayedProducts,
  selectFreeDisplayedProduct,
  selectPaidDisplayedProducts,
} from '@mkp/product-options/state';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import { AbstractProductDisplayService } from '../abstract-product-display/abstract-product-display.service';

@Injectable()
export class ProductDisplayReadOnlyService extends AbstractProductDisplayService {
  readonly activePlatformGroup$ = this.store.select(selectActivePlatformGroup(''));
  readonly products$ = this.store
    .select(selectPaidDisplayedProducts(''))
    .pipe(map(removeApprenticeshipProducts));
  readonly switchedProducts$ = this.store.select(selectDisplayedProducts('', false));
  // Note: Deprecated products are filtered at the API level (ProductResource)
  readonly displayedProducts$ = this.store.select(selectDisplayedProducts(''));
  readonly freeProduct$ = this.store.select(selectFreeDisplayedProduct(''));
  readonly features$: Observable<ProductOfferingFeature[]> = this.products$.pipe(
    map((products) => getFeaturesFromProducts(products)),
    map((feature) => orderFeatures(feature))
  );
  readonly platforms$: Observable<ProductOfferingPlatform[]> = this.features$.pipe(
    withLatestFrom(this.activePlatformGroup$),
    map(([features, activePlatformGroup]) =>
      getPlatformsFromFeatures(features, activePlatformGroup)
    )
  );
  readonly benefits$: Observable<ProductOfferingBenefit[]> = this.features$.pipe(
    map((f) => getBenefitsFromFeatures(f))
  );
}
